import { useState } from 'react';
import { Dayjs } from 'dayjs';
import { Filter, Genre } from '../../../../../../../../../constants/types';
import { formatAsDateString } from '../../../../../../../../../utils/time';
import { onAttributeChange } from '../../../../../../utils';

interface PendingFilterData {
  genreSelected: string;
  sectionSelected: string;
  attributeTypeSelected: string;
}

interface UseDatePickerFlowHook {
  showDatePicker: boolean;
  pendingFilterData: PendingFilterData | null;
  startDatePickerFlow: (genreSelected: string, sectionSelected: string, attributeTypeSelected: string) => void;
  getFiltersForDateSelection: (
    date: Dayjs | null,
    attributes: { genres: Genre[] },
    modalFilters: Filter[]
  ) => Filter[] | null;
  completeDatePickerFlow: () => void;
  handleDatePickerCancel: () => void;
}

export const useDatePickerFlow = (): UseDatePickerFlowHook => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [pendingFilterData, setPendingFilterData] = useState<PendingFilterData | null>(null);

  const startDatePickerFlow = (
    genreSelected: string,
    sectionSelected: string,
    attributeTypeSelected: string
  ) => {
    setShowDatePicker(true);
    setPendingFilterData({
      genreSelected,
      sectionSelected,
      attributeTypeSelected,
    });
  };

  const getFiltersForDateSelection = (
    date: Dayjs | null,
    attributes: { genres: Genre[] },
    modalFilters: Filter[]
  ): Filter[] | null => {
    if (date && pendingFilterData) {
      const dateString = formatAsDateString(date);
      return onAttributeChange(
        attributes,
        modalFilters,
        pendingFilterData.genreSelected,
        pendingFilterData.sectionSelected,
        pendingFilterData.attributeTypeSelected,
        dateString
      );
    }
    return null;
  };

  const completeDatePickerFlow = () => {
    setShowDatePicker(false);
    setPendingFilterData(null);
  };

  const handleDatePickerCancel = () => {
    setShowDatePicker(false);
    setPendingFilterData(null);
  };

  return {
    showDatePicker,
    pendingFilterData,
    startDatePickerFlow,
    getFiltersForDateSelection,
    completeDatePickerFlow,
    handleDatePickerCancel,
  };
};

